import {
    MouseOutlined,
    TextFieldsOutlined,
    CropSquareOutlined,
    RadioButtonUncheckedOutlined,
    ArrowRightAltOutlined,
    ImageOutlined,
} from '@mui/icons-material';

import { Tool } from './types';

export const TOOLS: Tool[] = [
    { key: 'select', label: 'Select', icon: <MouseOutlined /> },
    { key: 'text', label: 'Text', icon: <TextFieldsOutlined /> },
    { key: 'rectangle', label: 'Rectangle', icon: <CropSquareOutlined /> },
    { key: 'circle', label: 'Circle', icon: <RadioButtonUncheckedOutlined /> },
    { key: 'connector', label: 'Connector/Arrow', icon: <ArrowRightAltOutlined /> },
    { key: 'image', label: 'Image', icon: <ImageOutlined /> },
];

export const generateId = () =>
    Math.random().toString(36).substr(2, 9);
